import { render, staticRenderFns } from "./ApplicationSubmitError.vue?vue&type=template&id=45655ac0&scoped=true"
import script from "./ApplicationSubmitError.vue?vue&type=script&lang=ts"
export * from "./ApplicationSubmitError.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45655ac0",
  null
  
)

export default component.exports